import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SharedModule } from './../../shared/shared.module';
import { MaintenanceComponent } from './maintenance/maintenance.component';

export const routes = [{ path: 'login', component: LoginComponent }];

@NgModule({
	declarations: [LoginComponent, MaintenanceComponent],
	imports: [SharedModule, RouterModule.forChild(routes)  ],
	exports: [RouterModule],
})
export class AccountModule {}
